const isSessionStorageAvailable = () => (
  typeof window !== 'undefined' && window.sessionStorage
);

const getSessionValue = (key) => {
  if (!isSessionStorageAvailable()) {
    return undefined;
  }

  try {
    return window.sessionStorage.getItem(key) || undefined;
  }
  catch (err) {
    return undefined;
  }
};

const setSessionValue = (key, value) => {
  if (!isSessionStorageAvailable()) {
    return;
  }

  try {
    if (value === undefined || value === null) {
      window.sessionStorage.removeItem(key);
    }
    else {
      window.sessionStorage.setItem(key, value);
    }
  }
  catch (err) {
    // Ignore storage errors (blocked or quota exceeded).
  }
};

const clearSessionStorage = () => {
  sessionStorage.clear();
};

export {
  getSessionValue,
  setSessionValue,
  clearSessionStorage,
};
